import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { getUnique } from '../../../helpers/common'
import { useHandshakesWidget } from '../../common/widget/useHandshakesWidget'
import { FILTER_BY } from '../../constant'
import { createConnectionMapLogs } from '../../store/thunk'
import { changeLoading, changeRequestId, selectLoading } from '../store/slice'

const LegalBeneficialTab = ({ filterBy, filter = {} }) => {
  const dispatch = useDispatch()
  const { graphType, searchCompany } = filter
  const loading = useSelector(selectLoading('lbo'))
  const widgetInstance = useHandshakesWidget('#hs-widget-legal-beneficial-map')

  useEffect(() => {
    if (widgetInstance && searchCompany?.organizationId) {
      const id = getUnique()
      const datasets = ['CRVN']
      const entities = [
        {
          dataset: 'CRVN',
          id: `O-${searchCompany?.organizationId}`,
        },
      ]
      dispatch(
        createConnectionMapLogs({
          requestId: id,
          graphType,
          datasets: JSON.stringify(datasets),
          entities: JSON.stringify(entities),
        }),
      )
      dispatch(changeRequestId({ [graphType]: id }))
      dispatch(changeLoading({ lbo: true }))
      widgetInstance.drawGraphWithEndpointData({
        graphType,
        datasets,
        entities,
        degree: 1,
      })
    }
  }, [graphType, searchCompany?.organizationId, widgetInstance])

  if (!searchCompany?.organizationId) {
    return (
      <Element
        className="textCenter pt5 fw500"
        style={{ fontSize: 20, color: '#9C9C9C' }}
      >
        <Translate
          value={
            filterBy === FILTER_BY.PERSON
              ? 'connectMap.entityMap.PLEASE_SELECT_WARNING'
              : 'connectMap.entityMap.PLEASE_SELECT'
          }
        />
      </Element>
    )
  }

  return (
    <>
      <div id="hs-widget-legal-beneficial-map" className="h100" />
      {loading && <Loading style={{ background: '#fff' }} />}
    </>
  )
}

export default LegalBeneficialTab
